<template>
  <div v-if="isFetching" class="text-center">
    <b-spinner />
  </div>
  <b-card v-else title="รายการแทง">
    <b-tabs content-class="mt-3">
      <b-tab active title="รายยูส">
        <b-table :fields="fields" :items="byPlayerList" sort-by="createdAt" sort-desc striped>
          <template #cell(#)="data">
            {{ (pagination.currentPage - 1) * pagination.limit + data.index + 1 }}
          </template>

          <template #cell(username)="data">
            <b-link :to="`/players/detail/${data.item.userId}/info`" target="_blank">
              {{ data.item.user.username }}
            </b-link>
            <br>
            <small class="text-muted">({{ data.item.user.codeName }})</small>
          </template>

          <template #cell(winAmount)="data">
            {{ data.value | currency }}
          </template>

          <template #cell(createdAt)="data">
            {{ data.value | datetime }}
          </template>

          <template #cell(registeredAt)="data">
            {{ data.item.user.createdAt | datetime }}
          </template>
        </b-table>

        <b-row>
          <b-col>
            <LimitSelect v-model="pagination.limit" class="mb-3" />
          </b-col>
          <b-col>
            <PaginationInput
                :per-page="pagination.limit"
                :total="betList.length"
                @update="(val) => (pagination.currentPage = val)"
            />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="รายเลข">
        <b-table :fields="byNumberFields" :items="byNumberList" sort-by="betNumber" striped>
          <template #cell(#)="data">
            {{ (paginationNumber.currentPage - 1) * paginationNumber.limit + data.index + 1 }}
          </template>
        </b-table>
        <b-row>
          <b-col>
            <LimitSelect v-model="paginationNumber.limit" class="mb-3" />
          </b-col>
          <b-col>
            <PaginationInput
                :per-page="paginationNumber.limit"
                :total="byNumberList.length"
                @update="(val) => (paginationNumber.currentPage = val)"
            />
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {sortBy} from 'lodash';

export default {
  name: 'LottoDemoBetList',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pagination: {
        limit: 20,
        currentPage: 1,
      },
      paginationNumber: {
        limit: 20,
        currentPage: 1,
      },
      fields: [
        {
          key: '#',
          label: '#',
          sortable: true,
        },
        {
          key: 'username',
          label: this.$t('user.username'),
        },
        {
          key: 'betNumber',
          label: 'เลขที่แทง',
          sortable: true,
        },
        {
          key: 'winAmount',
          label: 'ถูกรางวัล',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'เวลาที่แทง',
          sortable: true,
        },
        {
          key: 'registeredAt',
          label: this.$t('user.registered_date'),
          sortable: true,
        },
      ],
      byNumberFields: [
        {
          key: '#',
          label: '#',
          sortable: true,
        },
        {
          key: 'betNumber',
          label: 'เลขที่แทง',
          sortable: true,
        },
        {
          key: 'count',
          label: 'จำนวน',
          sortable: true,
        },
        {
          key: 'winAmount',
          label: 'ถูกรางวัล',
          sortable: true,
        },
      ]
    }
  },
  computed: {
    ...mapState({
      betList: (state) => state['lotto-demo'].betList,
      isFetching: (state) => state['lotto-demo'].isFetchingBetList
    }),
    byPlayerList() {
      const start = (this.pagination.currentPage - 1) * this.pagination.limit
      return this.betList.slice(start, start + this.pagination.limit)
    },
    byNumberList() {
      const start = (this.paginationNumber.currentPage - 1) * this.paginationNumber.limit
      return sortBy(Object.values(this.betList.reduce((prev, curr) => {
        const betNumber = curr.betNumber
        if (!prev[betNumber]) {
          prev[betNumber] = {
            betNumber,
            count: 0,
            winAmount: 0
          }
        }
        prev[betNumber].count += 1
        prev[betNumber].winAmount += curr.winAmount || 0
        return prev
      }, {})), 'betNumber').slice(start, start + this.paginationNumber.limit)
    }
  },
  mounted() {
    this.getBetList()
  },
  methods: {
    ...mapActions(['fetchLottoDemoBetList']),
    getBetList() {
      this.fetchLottoDemoBetList(this.id)
    }
  }
}
</script>